import { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

let debounce = null;

export default class WeightInput extends PureComponent {
  static propTypes = {
    errors: PropTypes.array,
    onWeightChange: PropTypes.func.isRequired,
    reportId: PropTypes.string.isRequired,
    reportIndex: PropTypes.number.isRequired,
    weight: PropTypes.number,
  };

  static defaultProps = {
    weight: 1,
  };

  constructor(props) {
    super(props);

    this.state = {
      weight: props.weight,
    };
  }

  handleChange = handleEvent(({ target: { value } }) => {
    this.setState({ weight: value }, () => {
      if (debounce) {
        clearTimeout(debounce);
      }
      const { reportIndex } = this.props;
      debounce = setTimeout(() => {
        this.props.onWeightChange(reportIndex, this.state.weight);
      }, 400);
    });
  });

  handleDragStart = handleEvent((e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  render() {
    const { errors, reportId } = this.props;
    const { weight } = this.state;
    return (
      <input
        className={classNames(
          'form-control input-sm',
          'dashboard-color-form__weight-input',
          errors &&
            errors.indexOf(reportId) > -1 &&
            'dashboard-color-form__weight-input--error',
        )}
        data-disableremove='1'
        min={1}
        onChange={this.handleChange}
        type='number'
        value={weight}
        draggable='true'
        onDragStart={this.handleDragStart}
      />
    );
  }
}
